import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function AcademicTitlesIcon({ className }: IconProps) {
  return (
    <svg
      width="82"
      height="71"
      viewBox="0 0 82 71"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1617)">
        <path
          d="M71.9557 63.2932C72.1767 64.1985 72.4714 65.0792 72.8398 65.9355C72.5942 66.2047 72.3486 66.4493 72.103 66.694C71.3663 67.4279 67.1422 68.1619 66.3564 68.847H14.6858C13.728 68.847 12.7948 68.7246 11.9107 68.4555C10.2162 67.9907 8.6936 67.0854 7.46569 65.8621C5.84484 64.2474 4.76428 62.0944 4.54326 59.6967C4.5187 59.3542 4.49414 59.0361 4.49414 58.6936C4.49414 53.0909 9.06198 48.5403 14.6858 48.5403H74.3378C73.2572 50.2284 72.4959 52.0389 72.0048 53.8983C71.7101 54.9993 71.5136 56.1492 71.4399 57.2746C71.3663 58.1554 71.3663 59.0361 71.4399 59.8925C71.5136 61.0179 71.6855 62.1678 71.9557 63.2687V63.2932Z"
          fill="#EAF0F3"
        />
        <path
          d="M19.2783 7.21753H62.7464V28.9677H19.2783V7.21753Z"
          fill="#00416B"
        />
        <path
          d="M62.722 7.21753V13.0404H30.7963C29.3228 13.0404 28.1194 14.2392 28.1194 15.7072V28.9677H19.2539V7.21753H62.722Z"
          fill="#00416B"
        />
        <path
          d="M13.6051 65.8865C15.447 67.7215 18.001 68.8469 20.8007 68.8469H14.6857C11.886 68.8469 9.33197 67.7215 7.4901 65.8865C5.64823 64.0516 4.51855 61.5071 4.51855 58.718C4.51855 53.1154 9.08639 48.5647 14.7102 48.5647H20.8252C15.2014 48.5647 10.6336 53.1154 10.6336 58.718C10.6336 61.5071 11.7632 64.0516 13.6051 65.8865Z"
          fill="#DAE3E7"
        />
        <path
          d="M72.5457 37.335C72.5457 39.2433 71.7599 40.9804 70.5074 42.2282C69.2549 43.4759 67.5113 44.2588 65.5957 44.2588H12.7218C13.8761 42.4728 14.5146 40.4666 14.6865 38.4115C14.7847 37.286 14.7356 36.1606 14.5146 35.0352C14.2199 33.4204 13.6059 31.8546 12.6973 30.4111H65.5712C69.4023 30.4111 72.5212 33.5183 72.5212 37.335H72.5457Z"
          fill="#EAF0F3"
        />
        <path
          d="M16.9457 44.2588H12.7217C15.4231 40.0262 15.4231 34.6437 12.7217 30.4111H16.9457C19.6471 34.6437 19.6471 40.0262 16.9457 44.2588Z"
          fill="#DAE3E7"
        />
        <path
          d="M12.7705 46.4117L41.0862 50.4731L65.5707 46.4117C70.5806 46.4117 74.6819 42.3504 74.6819 37.3349C74.6819 32.3194 70.6052 28.2581 65.5707 28.2581H12.7705C11.5671 28.2581 10.6094 29.2122 10.6094 30.4111C10.6094 31.6099 11.5671 32.5641 12.7705 32.5641H65.5953C68.2476 32.5641 70.3842 34.6926 70.3842 37.3349C70.3842 39.9772 68.2476 42.1057 65.5953 42.1057H12.7705C11.5671 42.1057 10.6094 43.0599 10.6094 44.2587C10.6094 45.4576 11.5671 46.4117 12.7705 46.4117Z"
          fill="#00C4B3"
        />
        <path
          d="M10.6094 30.4111C10.6094 29.2122 11.5671 28.2581 12.7705 28.2581H18.0014C16.7981 28.2581 15.8403 29.2122 15.8403 30.4111C15.8403 31.6099 16.7981 32.5641 18.0014 32.5641H12.7705C11.5671 32.5641 10.6094 31.6099 10.6094 30.4111Z"
          fill="#00C4B3"
        />
        <path
          d="M18.0014 46.4117H12.7705C11.5671 46.4117 10.6094 45.4575 10.6094 44.2587C10.6094 43.0599 11.5671 42.1057 12.7705 42.1057H18.0014C16.7981 42.1057 15.8403 43.0599 15.8403 44.2587C15.8403 45.4575 16.7981 46.4117 18.0014 46.4117Z"
          fill="#00C4B3"
        />
        <path
          d="M76.4253 48.5649C76.4253 49.7637 75.4675 50.7179 74.2641 50.7179H14.6858C10.2653 50.7179 6.65526 54.3143 6.65526 58.7182C6.65526 63.1221 10.2653 66.7186 14.6858 66.7186H72.0784C70.5558 68.2599 68.935 69.7034 67.1914 71.0245H14.6858C7.88317 71.0245 2.33301 65.5197 2.33301 58.7182C2.33301 57.8864 2.40668 57.079 2.57859 56.2961C3.70827 50.6689 8.6936 46.4119 14.6858 46.4119H74.2641C75.4675 46.4119 76.4253 47.366 76.4253 48.5649Z"
          fill="#00416B"
        />
        <path
          d="M17.3381 70.9999H14.6858C7.88317 70.9999 2.33301 65.4951 2.33301 58.6935C2.33301 51.892 7.85861 46.3872 14.6858 46.3872H17.3381C10.5355 46.3872 4.9853 51.892 4.9853 58.6935C4.9853 65.4951 10.5109 70.9999 17.3381 70.9999Z"
          fill="#00416B"
        />
        <path
          d="M78.4391 3.37627H3.56095C1.59629 3.37627 0 4.94209 0 6.89936C0 8.85663 1.59629 10.4469 3.56095 10.4469H78.4391C80.4037 10.4469 82 8.85663 82 6.89936C82 4.94209 80.4037 3.35181 78.4391 3.35181V3.37627Z"
          fill="#00416B"
        />
        <path
          d="M13.7525 9.41929C14.391 10.0554 15.2751 10.4469 16.2574 10.4469H3.5608C2.57847 10.4469 1.69438 10.0554 1.05586 9.41929C0.417346 8.78318 0.0244141 7.90241 0.0244141 6.92377C0.0244141 4.9665 1.6207 3.37622 3.58536 3.37622H16.3065C14.3419 3.37622 12.7456 4.9665 12.7456 6.92377C12.7456 7.90241 13.1385 8.78318 13.777 9.41929H13.7525Z"
          fill="#00416B"
        />
        <path
          d="M72.0052 53.9229C71.7105 55.0238 71.514 56.1737 71.4403 57.2991H26.0812C25.6146 57.2991 25.1971 57.1034 24.8779 56.8098C24.5586 56.4918 24.3867 56.0758 24.3867 55.611C24.3867 54.6813 25.148 53.9229 26.0812 53.9229H72.0052Z"
          fill="#DAE3E7"
        />
        <path
          d="M55.3295 36.7233C55.3295 37.1882 55.133 37.6041 54.8383 37.9221C54.5191 38.2157 54.1016 38.4114 53.635 38.4114H14.6856C14.7838 37.286 14.7347 36.1606 14.5137 35.0352H53.6104C54.5436 35.0352 55.3049 35.7936 55.3049 36.7233H55.3295Z"
          fill="#DAE3E7"
        />
        <path
          d="M71.956 63.2933H33.0803C32.6137 63.2933 32.1962 63.0976 31.8769 62.804C31.5576 62.5104 31.3857 62.07 31.3857 61.6051C31.3857 60.6754 32.147 59.917 33.0803 59.917H71.4157C71.4894 61.0424 71.6613 62.1923 71.9314 63.2933H71.956Z"
          fill="#DAE3E7"
        />
        <path
          d="M72.2255 21.7992C71.2923 21.7992 70.531 21.0407 70.531 20.111V6.36118C70.531 4.6975 69.1803 3.35188 67.5104 3.35188H40.4963C39.5631 3.35188 38.8018 2.59344 38.8018 1.66373C38.8018 0.734028 39.5631 -0.0244141 40.4963 -0.0244141H67.5104C71.0222 -0.0244141 73.8955 2.83809 73.8955 6.33672V20.0865C73.8955 21.0162 73.1342 21.7747 72.201 21.7747L72.2255 21.7992Z"
          fill="#00C4B3"
        />
        <path
          d="M75.2218 21.1387H69.4997L67.4368 26.2765C66.6018 28.3561 68.1244 30.6314 70.3838 30.6314H74.3622C76.6216 30.6314 78.1442 28.3561 77.3092 26.2765L75.2463 21.1387H75.2218Z"
          fill="#00C4B3"
        />
        <path
          d="M72.0044 23.5118C74.2559 23.5118 76.0811 21.6935 76.0811 19.4505C76.0811 17.2075 74.2559 15.3892 72.0044 15.3892C69.7529 15.3892 67.9277 17.2075 67.9277 19.4505C67.9277 21.6935 69.7529 23.5118 72.0044 23.5118Z"
          fill="#00C4B3"
        />
        <path
          d="M73.9199 23.047C73.3551 23.3406 72.692 23.5118 72.0044 23.5118C69.7696 23.5118 67.9277 21.7014 67.9277 19.4505C67.9277 17.1996 69.745 15.3892 72.0044 15.3892C72.692 15.3892 73.3306 15.5604 73.9199 15.854C72.6429 16.5391 71.7588 17.8847 71.7588 19.426C71.7588 20.9674 72.6429 22.313 73.9199 22.998V23.047Z"
          fill="#00C4B3"
        />
        <path
          d="M72.938 30.6312H70.3594C68.1 30.6312 66.5774 28.3559 67.4124 26.2763L69.4753 21.1384H70.212C71.0961 21.1384 71.7101 22.0192 71.3663 22.851L69.991 26.2763C69.156 28.3559 70.6786 30.6312 72.938 30.6312Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1617">
          <rect width="82" height="71" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
